/** No navegador não há o que conectar: a leitura do QR Code é feita pelo app do celular. */
export function ConectarNavegador(_: { cor: string }) { return null; }
